import React, { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useSearchParams } from "react-router-dom";

import { ReduxState } from "./redux/store";
import { VideoChat } from "./pages/VideoChat/VideoChat";
import { routes } from "./routes";
import { Chat } from "./pages/Chat/Chat";
import { Error } from "./pages/Error/Error";
import { Player } from "./pages/Player/Player";
import { setPage } from "./redux/actions/Page";
import { Online } from "./pages/Online/Online";
import { env } from "./env";

export const Main = () => {
    const {currentPage} = useSelector(({page}: ReduxState) => page);
    const location = useLocation();
    const [params] = useSearchParams();
    const dispatch = useDispatch();

    const listener = useCallback(
        (event: any) => {
            if ((event.data?.isActualCommunicationData || event.data?.isActualCommunicationOnlineData) && event.data?.data) {
                const data = event.data.data;
                const mainColor = data?.mainColor;
                const chatBackgroundColor = data?.chatBackgroundColor;
                if ((data.userId || data.sessionId) && data.route === routes.messenger) {
                    dispatch(setPage(routes.messenger, {userId: !env().REACT_APP_USE_TM_AUTH ? data.userId : null, sessionId: data.sessionId, externalRoomId: data.externalRoomId, 
                        link: data.link, showChats: data.showChats, serviceType: data.serviceType, contextUrl: data.contextUrl}))
                }
                if (data.sessionId && data.roomId && data.route === routes.videoChat) {
                    dispatch(setPage(routes.videoChat, {sessionId: data.sessionId, roomId: data.roomId, link: data.link, serviceType: data.serviceType}));
                }
                if (data.sessionId && data.route === routes.online) {
                    dispatch(setPage(routes.online, {sessionId: data.sessionId, link: data.link, serviceType: data.serviceType, contextUrl: data.contextUrl}));
                }
                if (chatBackgroundColor && chatBackgroundColor.length > 0) {
                    document.documentElement.style.setProperty(
                        '--messenger-chat-background',
                        chatBackgroundColor
                    );
                }
                if (mainColor && mainColor.length > 0) {
                    document.documentElement.style.setProperty(
                        '--messenger-blue',
                        mainColor
                    );
                }
            }
        },
        []
    );
    
    useEffect(() => {
        if (location.pathname.includes(routes.messenger)) {
            dispatch(setPage(routes.messenger, {showChats: true}));
        }
        if (location.pathname.includes(routes.error)) {
            dispatch(setPage(routes.error, {text: params.get('text')}));
        }
        if (location.search.includes(routes.player)) {
            dispatch(setPage(routes.player, {fileName: params.get('fileName')}));
        }
    }, [location]);

    useEffect(() => {
        try {
            if (window.addEventListener) {
                window.postMessage("communicationLoad", "*");
                window.addEventListener("message", listener, false);
            }

            return () => window.removeEventListener("message", listener);
        } catch (err) {
            console.error("Error Listener: ", err);
        }
    }, [listener]);
    
    switch (currentPage) {
        case routes.online:
            return <Online />
        case routes.messenger:
            return <Chat />;
        case routes.player:
            return <Player />;
        case routes.error:
            return <Error />;
        default:
            return <VideoChat />
    }
}